import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { EventDetailsSectionTitle } from '../EventDetails/EventDetails';

export type ShareInlineProps = {
    hasShareInline: boolean;
};

export const ShareInline = ({ hasShareInline }: ShareInlineProps) => {
    if (!hasShareInline) {
        return null;
    }

    return (
        <section
            className="share-inline"
            aria-labelledby="share-inline-heading"
        >
            <div className="l-sm-mar-bot-4">
                <EventDetailsSectionTitle>
                    <h3>{gettext('Share with friends')}</h3>
                </EventDetailsSectionTitle>
                <div id="listings-root__share-event"></div>
            </div>
        </section>
    );
};
